module.exports = __webpack_public_path__ + "static/media/setupcalculatoricon.ebde3b01.svg";